module Tapas.Bindings {
    export interface ISpinEditBindingParams {
        minimum: number;
        updateObservable: KnockoutObservable<number>;
    }

    export class SpinEdit {
        public init(element: any, valueAccessor: () => ISpinEditBindingParams, allBindingsAccessor?: KnockoutAllBindingsAccessor, viewModel?: any, bindingContext?: KnockoutBindingContext) {
            if (!bindingContext)
                return;

            var params = valueAccessor();
            if (params.updateObservable) {
                $(element).val(params.updateObservable());
                $(element).spinedit(params.updateObservable);

            } else {
                $(element).spinedit(params.minimum);

            }

            $(element).on("valueChanged", (e: any) => {
                $(element).parent().parent().find(".addToCart").attr("ftw-quantity", e.value);
                //$(element).parent().parent().find(".ordertemplatedialogquantity").attr("ftw-quantity", e.value);
                if (params.updateObservable) {
                    params.updateObservable(e.value);
                }
                //params.updateObservable(e.value);
            });


        }
    }
    ko.bindingHandlers['spinEdit'] = new SpinEdit();
} 